export const GET_ALL_USER_DATA = 'GET_ALL_USER_DATA';
